// extracted by mini-css-extract-plugin
export default {"form":"AddCard_form__gQBlN","input_file":"AddCard_input_file__NNbcF","atributes":"AddCard_atributes__kkPaX"};